import { CalendarClock, UserPlus, Video } from 'lucide-react';

const STEPS = [
  {
    step: '1',
    title: 'Crie sua conta',
    description: 'Cadastre-se em poucos minutos e acesse o App Saúde.',
    icon: UserPlus,
  },
  {
    step: '2',
    title: 'Agende ou chame',
    description: 'Escolha telemedicina ou atendimento quando precisar.',
    icon: CalendarClock,
  },
  {
    step: '3',
    title: 'Casa ou vídeo',
    description: 'Receba o profissional em casa ou faça a consulta por vídeo.',
    icon: Video,
  },
] as const;

export function LandingHowItWorks() {
  return (
    <section id="como-funciona" className="scroll-mt-20 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
          Como <span className="text-teal-700">funciona</span>
        </h2>
        <p className="mt-3 max-w-xl text-base text-neutral-600">
          Três passos para cuidar da sua saúde sem sair do seu ritmo.
        </p>

        <ol className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map(({ step, title, description, icon: Icon }) => (
            <li
              key={step}
              className="relative rounded-2xl border border-neutral-200 bg-white p-6"
            >
              <span className="absolute top-5 right-5 text-3xl font-bold text-teal-100">
                {step}
              </span>
              <span className="inline-flex size-11 items-center justify-center rounded-full bg-teal-50 text-teal-700">
                <Icon className="size-5" aria-hidden />
              </span>
              <h3 className="mt-4 text-lg font-semibold text-neutral-900">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-600">{description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
